import { createClient } from '@supabase/supabase-js';

// Hardcoded configuration to resolve production environment variable issues.
// These should be moved to secure environment variables in the future.
const supabaseUrl = 'https://lfuqfxzfkfuiyvnttprr.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxmdXFmeHpma2Z1aXl2bnR0cHJyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjkyNTU3NDEsImV4cCI6MjA4NDgzMTc0MX0.S-fUf4Ep_DyCoZGBQOrG9NSN3oPwvlMwTIBG3RB1HZ0';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Helper to check connection
export const checkSupabaseConnection = async () => {
  try {
    const { error } = await supabase.from('menu_items').select('count', { count: 'exact', head: true });
    return !error;
  } catch (e) {
    console.error('Supabase connection check failed:', e);
    return false;
  }
};
